"use strict";

exports.__esModule = true;
exports.clone = clone;
/**
 * Creates a shallow copy of a given advanced seo data.
 *
 * @param {Object} value advanced seo data to clone.
 */
function clone(value) {
  return {
    tags: (value || {}).tags || []
  };
}